const pending = new Map();
const modules = new Map();

function loadSection(section) {
  const markers = pending.get(section) || [];
  pending.delete(section);
  for (const marker of markers) {
    const url = marker.dataset.sweDeferredModule;
    if (!modules.has(url)) {
      modules.set(url, import(url).catch(error => {
        console.warn('Unable to load section animation.', error);
      }));
    }
  }
}

const observer = 'IntersectionObserver' in window && !window.Shopify?.designMode
  ? new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        loadSection(entry.target);
        observer.unobserve(entry.target);
      }
    }, { rootMargin: '600px 0px' })
  : null;

function discover(root) {
  for (const marker of root.querySelectorAll('template[data-swe-deferred-module]')) {
    if (marker.dataset.sweObserved) continue;
    marker.dataset.sweObserved = 'true';
    const section = marker.closest('.shopify-section') || marker.parentElement;
    const markers = pending.get(section) || [];
    markers.push(marker);
    pending.set(section, markers);
    if (observer) observer.observe(section);
    else loadSection(section);
  }
}

discover(document);
document.addEventListener('shopify:section:load', event => discover(event.target));
document.addEventListener('shopify:section:unload', event => {
  observer?.unobserve(event.target);
  pending.delete(event.target);
});
